import * as actionTypes from "./actionTypes";

export const getGiftExchangePointAction = params => ({
	type: actionTypes.GET_GIFT_EXCHANGE_POINT_ACTION,
	params
});

export const setGiftExchangePointAction = params => ({
	type: actionTypes.SET_GIFT_EXCHANGE_POINT_ACTION,
	params
});

export const createOrderExchangePointAction = params => ({
	type: actionTypes.CREATE_ORDER_EXCHANGE_POINT_ACTION,
	params
});
